import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {RolesRouter} from 'src/admin-rights-service';
import {AdvancedSearchResult} from 'src/modules/advanced-search-result';
import {AddAttendees} from 'src/modules/bulk-update/add-attendees';
import {CreateAccount} from 'src/modules/create-account';
import {CreatePreparedConference} from 'src/modules/create-conference';
import {CreateUsers} from 'src/modules/create-user';
import {PageNotFound} from 'src/modules/error-page';
import {FullStoryConfigurator} from 'src/modules/full-story-configurator';
import {Home} from 'src/modules/home';
import {InternalNotificationRouter} from 'src/modules/internal-notification/internal-notification-router';
import {LiveAgentConfigurator} from 'src/modules/live-agent-configurator';
import {ManageEntitlementsRouter} from 'src/modules/manage-entitlements/manage-entitlements-router';
import {PlatformAlertBuilderRouter} from 'src/modules/platform-alert-builder';
import {AccountPage} from 'src/modules/profile/account';
import {HubspotOauthCallback} from 'src/modules/profile/account/tabs/license-and-features/crm-tab/sections/hubspot/hubspot-oauth-callback';
import {MsDynamicsOauthCallback} from 'src/modules/profile/account/tabs/license-and-features/crm-tab/sections/ms-dynamics/ms-dynamics-oauth-callback';
import {SalesforceOauthCallback} from 'src/modules/profile/account/tabs/license-and-features/crm-tab/sections/salesforce/salesforce-oauth-callback';
import {UserPage} from 'src/modules/profile/user/user-page';
import {SearchCriteria} from 'src/modules/search-criteria';
import {SsoAccounts, SsoSettingsProfile} from 'src/modules/sso-accounts';

export const Router = () => (
    <Routes>
        <Route path="/" element={<Home/>}/>

        <Route path="/search-criteria/:searchId/*" element={<SearchCriteria/>}/>
        <Route path="/search-result/:searchId/*" element={<AdvancedSearchResult/>}/>

        <Route path="/profile/user/:userId/*" element={<UserPage/>}/>
        <Route path="/profile/account/:accountId/*" element={<AccountPage/>}/>

        <Route path="/create-new-account/:accountId?" element={<CreateAccount/>}/>
        <Route path="/create-new-conference" element={<CreatePreparedConference/>}/>
        <Route path="/create-new-user/:accountId" element={<CreateUsers/>}/>

        <Route path="/add-attendees/:accountId" element={<AddAttendees/>}/>

        <Route path="/crm/salesforce/oAuthCallback/*" element={<SalesforceOauthCallback/>}/>
        <Route path="/crm/ms-dynamics/oAuthCallback/*" element={<MsDynamicsOauthCallback/>}/>
        <Route path="/crm/hubspot/oAuthCallback/*" element={<HubspotOauthCallback/>}/>

        <Route path="/roles/*" element={<RolesRouter/>}/>
        <Route path="/entitlements/*" element={<ManageEntitlementsRouter/>}/>
        <Route path="/live-agent-configurator" element={<LiveAgentConfigurator/>}/>
        <Route path="/platform-alert-builder/*" element={<PlatformAlertBuilderRouter/>}/>
        <Route path="/internal-notification/*" element={<InternalNotificationRouter/>}/>
        <Route path="/full-story-configurator" element={<FullStoryConfigurator/>}/>
        <Route path="/sso-accounts" element={<SsoAccounts/>}/>
        <Route path="/sso-accounts/:accountId" element={<SsoSettingsProfile/>}/>

        <Route path="/logout" element={<Navigate to="/" replace={true}/>}/>
        <Route path="*" element={<PageNotFound/>}/>
    </Routes>
);
